import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import frCommon from "./locales/fr/common.json";
import frErrors from "./locales/fr/errors.json";
import frAuth from "./locales/fr/auth.json";
import frNav from "./locales/fr/nav.json";
import frSubscription from "./locales/fr/subscription.json";
import frPublic from "./locales/fr/public.json";
import frLegal from "./locales/fr/legal.json";
import frClient from "./locales/fr/client.json";
import frComponents from "./locales/fr/components.json";
import frAdmin from "./locales/fr/admin.json";
import frPharmacy from "./locales/fr/pharmacy.json";
import frSeller from "./locales/fr/seller.json";

import enCommon from "./locales/en/common.json";
import enErrors from "./locales/en/errors.json";
import enAuth from "./locales/en/auth.json";
import enNav from "./locales/en/nav.json";
import enSubscription from "./locales/en/subscription.json";
import enAdmin from "./locales/en/admin.json";
import enPublic from "./locales/en/public.json";
import enLegal from "./locales/en/legal.json";
import enClient from "./locales/en/client.json";
import enComponents from "./locales/en/components.json";
import enPharmacy from "./locales/en/pharmacy.json";
import enSeller from "./locales/en/seller.json";

export const STORAGE_KEY = "omu_lang";
export const DEFAULT_LANGUAGE = "fr";
export const SUPPORTED_LANGUAGES = ["fr", "en"];

const saved = localStorage.getItem(STORAGE_KEY);
const initialLanguage = SUPPORTED_LANGUAGES.includes(saved) ? saved : DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      common: frCommon,
      errors: frErrors,
      auth: frAuth,
      nav: frNav,
      subscription: frSubscription,
      public: frPublic,
      legal: frLegal,
      client: frClient,
      components: frComponents,
      admin: frAdmin,
      pharmacy: frPharmacy,
      seller: frSeller,
    },
    en: {
      common: enCommon,
      errors: enErrors,
      auth: enAuth,
      nav: enNav,
      subscription: enSubscription,
      public: enPublic,
      legal: enLegal,
      client: enClient,
      components: enComponents,
      admin: enAdmin,
      pharmacy: enPharmacy,
      seller: enSeller,
    },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  defaultNS: "common",
  ns: ["common", "errors", "auth", "nav", "subscription", "admin", "public", "legal", "client", "components", "pharmacy", "seller"],
  interpolation: { escapeValue: false },
});

document.documentElement.lang = initialLanguage;

export function setAppLanguage(lang) {
  const next = SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
  localStorage.setItem(STORAGE_KEY, next);
  document.documentElement.lang = next;
  return i18n.changeLanguage(next);
}

export default i18n;
